import { Injectable } from '@angular/core';
import { Absence, Approval, Employee, Leave, Message } from '../models/domain';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppearanceService {

  constructor(private httpClient: HttpClient) { }

  //LEAVE API'S
  public createLeave(leave: Leave): Observable<Leave> {
    return this.httpClient.post<Leave>(`/api/leave/v1`, leave);
  }

  public getLeave(id: number): Observable<Leave> {
    return this.httpClient.get<Leave>(`/api/leave/v1/${id}`);
  }

  public getLeaves(employee: number, startDate?: string, endDate?: string, status?: string, all?: boolean): Observable<Leave[]> {
    return this.httpClient.get<Leave[]>(`/api/leave/v1?employee=${employee}`, { params: { ...(startDate && { startDate }), ...(endDate && { endDate }), ...(status && { status }), ...(all && { all }) } });
  }

  public updateLeave(id: number, leave: Leave): Observable<Leave> {
    return this.httpClient.put<Leave>(`/api/leave/v1/${id}`, leave);
  }

  public deleteLeave(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/leave/v1/${id}`);
  }

  public getVacation(): Observable<string[]> {
    return this.httpClient.get<string[]>(`/api/leave/v1/vacation`);
  }

  public getSanction(): Observable<string[]> {
    return this.httpClient.get<string[]>(`/api/leave/v1/sanction`);
  }

  public tocheckIfLeaveIsApplicable(id: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/leave/v1/check/${id}`);
  }

  public verifyEmployeeReportTo(employee: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/leave/v1/apply?employee=${employee}`);
  }

  //APPROVAL API'S
  public getApprovals(approver: number, startDate?: string, endDate?: string, status?: string): Observable<Leave[]> {
    return this.httpClient.get<Leave[]>(`/api/leave/v1/approval?approver=${approver}`, { params: { ...(startDate && { startDate }), ...(endDate && { endDate }), ...(status && { status }) } });
  }

  public getStatus(): Observable<string[]> {
    return this.httpClient.get<string[]>(`/api/leave/v1/status`);
  }

  public approval(approval: Approval): Observable<Message> {
    return this.httpClient.put<Message>(`/api/leave/v1`, approval);
  }

  //REGULAR API'S
  public createRegular(regular: Leave): Observable<Leave> {
    return this.httpClient.post<Leave>(`/api/regular/v1`, regular);
  }

  public getRegular(id: number): Observable<Leave> {
    return this.httpClient.get<Leave>(`/api/regular/v1/${id}`);
  }

  public getRegulars(employee: number, startDate?: string, endDate?: string, status?: string): Observable<Leave[]> {
    return this.httpClient.get<Leave[]>(`/api/regular/v1?employee=${employee}`, { params: { ...(startDate && { startDate }), ...(endDate && { endDate }), ...(status && { status }) } });
  }

  public updateRegular(id: number, regular: Leave): Observable<Leave> {
    return this.httpClient.put<Leave>(`/api/regular/v1/${id}`, regular);
  }
  public deleteRegular(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/regular/v1/${id}`);
  }

  public tocheckIfRegularIsApplicable(id: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/regular/v1/check/${id}`);
  }
  public validateReportForEmployee(employee: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/regular/v1/apply?employee=${employee}`);
  }

  public getRegularApprovals(approver: number, startDate?: string, endDate?: string, status?: string): Observable<Leave[]> {
    return this.httpClient.get<Leave[]>(`/api/regular/v1/approval?approver=${approver}`, { params: { ...(startDate && { startDate }), ...(endDate && { endDate }), ...(status && { status }) } });
  }

  public Regularapproval(approval: Approval): Observable<Message> {
    return this.httpClient.put<Message>(`/api/regular/v1`, approval);
  }

  public getRegulation(): Observable<string[]> {
    return this.httpClient.get<string[]>(`/api/regular/v1/regulation`);
  }

  public getRegularReports(employee: number, startDate?: string, endDate?: string, status?: string, all?: boolean): Observable<Leave[]> {
    return this.httpClient.get<Leave[]>(`/api/regular/v1/report?employee=${employee}`, { params: { ...(startDate && { startDate }), ...(endDate && { endDate }), ...(status && { status }), ...(all && { all }) } });
  }

  //ABSENCE API'S
  public getAbsences(employee: number, startDate?: string, endDate?: string,status?:string): Observable<Absence[]> {
    return this.httpClient.get<Absence[]>(`/api/absence/v1?employee=${employee}`, { params: { ...(startDate && { startDate }), ...(endDate && { endDate }),status } });
  }

  public getAbsence(id: number): Observable<Absence> {
    return this.httpClient.get<Absence>(`/api/absence/v1/${id}`);
  }

  public createAbsence(absence: Absence): Observable<Absence> {
    return this.httpClient.post<Absence>(`/api/absence/v1`, absence);
  }

  public updateAbsence(id: number, absence: Absence): Observable<Absence> {
    return this.httpClient.put<Absence>(`/api/absence/v1/${id}`, absence);
  }

  public deleteAbsence(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/absence/v1/${id}`);
  }

  public getEmployeeList(approver: number): Observable<Employee[]> {
    return this.httpClient.get<Employee[]>(`/api/absence/v1/approval?approver=${approver}`);
  }
}
